<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">积分兑换比例设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :model="formInline" label-width="120px" :rules="rules" class="user-search">
            <el-form-item label="" prop="">
                用户在商城购买商品时，发放的积分与人民币换算比例
                <el-input size="small" style="width:350px" v-model="DivisionData[0]" :disabled="editFlag" placeholder="">
                    <template slot="prepend">1元</template>
                    <template slot="append">积分</template>
                </el-input>
            </el-form-item>
            <el-form-item label="" prop="num">
                用户在商城购买商品时，使用积分抵现的换算比例
                <el-input size="small" style="width:350px" v-model="DivisionData[1]" :disabled="editFlag" placeholder="">
                    <template slot="prepend">1元</template>
                    <template slot="append">积分</template>
                </el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="submitData">保存</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { integralDivision , updateIndiv } from '../../../api/userMG'
export default {
    data(){
        return{
            DivisionData:[],
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                num: [
                { required: true, message: '请输入积分', trigger: 'blur' },
                // { type: 'number', required: true, message: '格式错误', trigger: 'change' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ },
                ],
                palyTimes: [
                { required: true, message: '请输入对局数', trigger: 'blur' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                taskType: [
                { required: true, message: '请选择具体任务', trigger: 'blur' }
                ],
                userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        submitData(){
            updateIndiv(this.DivisionData).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.$message.success('修改成功')
                }
            })
        },
        handleEdit(row){
            this.detailsFlag = true

        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            integralDivision().then(res=>{
                this.DivisionData = res.data
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/shoppingMall/activity/RedemptionOfPoints.vue